import * as React from "react";
import { ExternalLink } from "lucide-react";

import { cn } from "@/lib/utils";

export interface ExternalLinkTextProps extends React.ComponentProps<"a"> {
  truncate?: boolean;
  iconClassName?: string;
}

export function ExternalLinkText({
  children,
  className,
  iconClassName,
  truncate = false,
  target = "_blank",
  rel = "noopener noreferrer",
  ...props
}: ExternalLinkTextProps) {
  return (
    <a
      target={target}
      rel={rel}
      className={cn("inline-flex w-fit max-w-full items-center gap-1", className)}
      {...props}
    >
      <span className={cn(truncate ? "truncate" : null)}>{children}</span>
      <ExternalLink className={cn("size-3 shrink-0", iconClassName)} />
    </a>
  );
}
